<template>
  <div class="page  overflow-y-auto overflow-touch">
    <div class="bindPhone">
      <div class="bindPhoneCenter">
        <div class="bigMiddle">
          <p>
            <img src="../../../static/img/填写手机号.png" alt="">
            <span>请先填写您的手机号</span>
          </p>
        </div>
        <div class="aboutNumber">
          <div class="formContent" ref="formContent">
            <div class="form phone border-1px">
              <label for="" class="phoneLabel"> <img src="../../../static/img/手机号.png" alt=""> </label>
              <input type="number" placeholder="请输入手机号" @focus="focus()" @blur="blur()"
                     v-model.trim="phone"
                     @input="$v.phone.$touch()" class="numberInput">
            </div>
            <div class="form verifyCode border-1px">
              <label for="" class="codeLabel"> <img src="../../../static/img/验证码.png" alt=""> </label>
              <input type="number" :maxlength="4" @focus="focus()" @blur="blur()" placeholder="请输入验证码"
                     class="codeInput"
                     v-model="code">
              <span @click="getCode" v-if="countdown == 60 || countdown == 0">获取验证码</span>
              <span v-else>{{ countdown }}s后重新获取</span>
            </div>
          </div>
          <div class="buttonWrap">
            <button class="bottom" @touchend="verifyCode()">下一步</button>
          </div>
          <div class="tar mt15" v-if="is5_8_0">
            <router-link :to="{path:'/account/login',query:$route.query}" class="color_main">密码登录</router-link>
          </div>
        </div>
      </div>
      <div class="verifyCenter">
        <verify v-if="showVerify" :verifyTips="verifyTips"></verify>
      </div>
    </div>
    <msg ref="msg"></msg>
  </div>
</template>
<script>
import Msg from '../../plugins/msg'
import header from '../../base/header'
import api from '../../lib/api.js'
import mask from '../../base/mask'
import verify from '../../base/verify'
import {openidCache, tokenCache} from "@/lib/cache";
import {getENV, isAlipay, isBrower, isWeixin} from "@/lib/util";
import {isBindMixin, isLoginMixin, scrollIntoViewMixin} from "@/lib/mixin"
import {between, minLength, required} from 'vuelidate/lib/validators'
import validate from "../../lib/validate";
import {FEICHANGYONGSHEBEI_CODE, MAIN_COLOR} from "@/lib/config";
import {userService} from "@/services/user";
import {OkHttp} from "@/services/base";
import {Dialog} from "vant";

export default {
  name: 'bindRelativePhone',
  mixins: [isLoginMixin, scrollIntoViewMixin, isBindMixin],
  data() {
    return {
      phone: "",
      code: "",
      cid: "",
      codeValue: "",
      showMask: false,
      regStatus: "",
      showVerify: false,
      verifyTips: "手机号不能为空",
      countdown: 60,
      a: "",
      backPath: "",
      docId: "",
      query: this.$route.query
    }
  },
  validations: {
    phone: {
      required,
      minLength: minLength(4)
    },
    age: {
      between: between(20, 30)
    }
  },
  async created() {
    this.docId = this.$route.query.docId;
    this.backPath = this.$route.query.backPath || '/Profile';
    this.patId = this.$route.query.patId;
    this.promoteCode = this.$route.query.promoteCode;
    this.exclusiveCodeId = this.$route.query.exclusiveCodeId;
    this.phone = this.query.mobile || this.query.phone || "";

    const {openId} = this.$route.query;

    const {code, ...user} = await userService.get();

    // 1、已有用户信息，跳出本页面
    if (user && user.patId) {
      if (this.docId)
        return this.$router.replace({
          path: "/onlineDoctorCard",
          query: {docId: this.docId}
        });
      return this.$router.replace(this.backPath);
    }

    // 1.1 扫描医生二维码
    if (this.docId) {
      return this._redirectLoginDoc(this.docId, this.exclusiveCodeId, openId, this.backPath, this.promoteCode);
    }

    // 2、支付宝处理
    if (isAlipay()) {
      return this.handlerAlipay()
    }

    // 3、微信打开
    if (isWeixin()) {
      if (!openId) {
        return this._redirectPreLogin(this.exclusiveCodeId, this.docId, this.backPath, this.promoteCode);
      }
    }
  },
  methods: {
    async handlerAlipay() {
    },


    async bind() {
      const query = this.$route.query;
      let extra = {};
      if (this.isAlipay) extra = {alipayUserId: openidCache.get()}
      else extra = {openId: query.openId}

      let data = await OkHttp.$http("nethos.pat.wechat.bind", {
        captcha: this.code,
        cid: this.cid,
        deviceId: extra.openId || extra.alipayUserId,
        promoteCode: this.promoteCode,
        ...extra
      });

      if (data.code == 0) {
        tokenCache.set(data.token);
        this.$router.replace({
          path: '/login',
          query: {backPath: this.backPath}
        })
      } else if (data.code === FEICHANGYONGSHEBEI_CODE) {
        this.$router.replace({
          path: '/account/notice',
          query: {
            callback: this.backPath,
            openId: query.openId || extra.alipayUserId,
            mobile: this.phone
          }
        })
      } else {
        Dialog.confirm({
          confirmButtonColor: MAIN_COLOR,
          message: (data.msg || "接口错误" + data.code) + ' 是否重新尝试？',
        }).then(() => {
          this._redirectPreLogin(this.exclusiveCodeId, this.docId, this.backPath, this.promoteCode);
        }).catch(() => {
          this.$router.back();
        })
        // this.$refs.msg.show(data.msg || "接口错误" + data.code);
      }
    },
    async getCode() {
      /*if (this.phone == "") {
        this.$refs.msg.show('手机号不能为空');
        return
      }*/
      const v = new validate();

      v.add(this.phone, [
        ['need', '手机号不能为空'],
        ['isPhone', '手机号格式错误']
      ])
      const error = v.start();
      if (error) {
        return this.$refs.msg.show(error);
      }

      let ret = await OkHttp.$http("nethos.system.captcha.pat.wechat.bind", {
        mobile: this.phone,
        needToken: false
      });

      if (ret.code == 0) {
        this.regStatus = ret.regStatus;
        this.cid = ret.obj.cid;
        this.codeValue = ret.obj.value;
        let env = getENV();
        (env.plat !== 'pro') && (this.codeValue) && (this.code = this.codeValue);
        this.a = setInterval(() => {
          this.countdown--
        }, 1000)
      } else {
        this.$refs.msg.show(ret.msg || "接口错误" + ret.code);
      }
    },
    async verifyCode() {
      const v = new validate();
      v.add(this.phone, [
        ['need', '手机号不能为空'],
        ['isPhone', '手机号格式错误']
      ])
      const error = v.start();
      if (error) {
        return this.$refs.msg.show(error);
      }
      if (this.code == '') {
        this.$refs.msg.show("验证码不能为空");
      } else if (!this.cid) {
        this.$refs.msg.show("验证码不正确");
      } else {
        let ret = await api('nethos.system.captcha.checkcaptcha.v2', {
          captcha: this.code,
          cid: this.cid
        })
        if (ret.code != 0) {
          this.$refs.msg.show("验证码不正确");
          return false;
        }

        if (this.regStatus == 'REGISTER') {
          this.$router.replace({
            path: '/register',
            query: {
              cid: this.cid,
              codeValue: this.code,
              backPath: this.backPath,
              mobile: this.phone,
              promoteCode: this.promoteCode,
              patId: this.patId,
              openId: this.$route.query.openId,
              exclusiveCodeId: this.$route.query.exclusiveCodeId
            }
          })
        } else if (this.regStatus == 'BIND') {
          await this.bind()
        }
      }
    },
    focus() {
    },
    blur() {
    }
  },
  components: {
    "VHeader": header,
    "VMask": mask,
    verify, Msg
  },
  watch: {
    code(newV) {
      if (newV.length > 4) {
        this.code = this.code.slice(0, 4);
      }
    },
    phone() {
      if (!this.$v.phone.required) {
        this.showVerify = true
        setTimeout(() => {
          this.showVerify = false
        }, 1000)
      }
    },
    countdown() {
      if (this.countdown == 0) {
        clearInterval(this.a)
        this.countdown = 60
      }
    }
  }
}
</script>
<style scoped lang="scss">
@import '../../common/public.scss';

.page {
  flex-direction: column;
}

.bindPhone {
  .verifyCenter {
  }

  .bindPhoneCenter {
    width: 690rem/$rem;
    margin: 0 auto;

    .bigMiddle {
      margin-top: 100rem/$rem;
      font-size: 32rem/$rem;
      color: #333333;
      display: flex;
      align-items: center;
      justify-content: center;

      p {
        display: flex;
        flex-direction: column;
        align-items: center;

        img {
          width: 319rem/$rem;
          height: 246rem/$rem;
          margin-bottom: 85rem/$rem;
        }

        span {
          font-size: 50rem/$rem;
          color: #333333;
        }
      }
    }

    .verifyTips {
      margin-top: 130rem/$rem;
      position: relative;
      text-align: center;
    }

    .aboutNumber {
      background-color: white;
      border-radius: 7px;
      /*<!--margin-top: 18rem/$rem;-->*/
      /*<!--height:500rem/$rem;-->*/
      .formContent {
        width: 690rem/$rem;
        margin: 0 auto;
        margin-top: 10px;

        .form {
          width: 100%;
          height: 40px;
          line-height: 40px;
          display: flex;
          margin-top: 1px;

          label {
            width: 60px;
            padding-left: 1rem;
            /*<!--background-color: $bgColor2;-->*/
          }

          label.phoneLabel {
            border-top-left-radius: 7px;
            display: flex;
            align-items: center;
            justify-content: center;

            img {
              height: 50rem/$rem;
              width: 30rem/$rem;
            }
          }

          label.codeLabel {
            border-bottom-left-radius: 7px;
            display: flex;
            align-items: center;
            justify-content: center;

            img {
              height: 45rem/$rem;
              width: 40rem/$rem;
            }
          }

          input {
            flex: 1;
            text-align: left;
            border: none;
            outline: medium;
            font-size: 32rem/$rem;
            color: #999999;
            /*<!--background-color: $bgColor2;-->*/
          }

          input.codeInput {
            border-bottom-right-radius: 7px;
          }

          p {
            flex: 1;
            font-size: 32rem/$rem;
            color: #999999;
            /*<!--background-color: $bgColor2;-->*/
            border-top-right-radius: 7px;
          }
        }

        .phone {
          /*margin-top: 20px;*/
        }

        .verifyCode {
          position: relative;
          height: 109rem/$rem
        }

        .verifyCode span {
          position: absolute;
          display: inline-block;
          top: 30rem/$rem;
          text-align: center;
          right: 0;
          height: 57rem/$rem;
          line-height: 57rem/$rem;
          width: 190rem/$rem;
          font-size: 26rem/$rem;
          border: 1px solid #3Dccc2;
          border-radius: 5px;
          color: #3Dccc2;
        }
      }

      .buttonWrap {
        width: 690rem/$rem;
        height: 90rem/$rem;
        margin-top: 69rem/$rem;
        text-align: center;
      }

      button.bottom {
        width: 650rem/$rem;
        height: 90rem/$rem;
        border: none;
        outline: medium;
        border-radius: 22px;
        color: white;
        font-size: 36rem/$rem;
        background-color: $buttonColor;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bindAccount/bindRelativePhone.vue